import React, { useState, useEffect } from 'react';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';
import { createTheme } from '@uhg-abyss/web/tools/theme';
import { HashRouter } from '@uhg-abyss/web/tools/reactRouterTools/reactRouterDom';
import { StateMachineProvider, createStore } from 'little-state-machine';
import { App } from '@src/app/App';
import { Provider } from 'react-redux';
import { LagoonContext } from './AppContext/LagoonContext';
import { LoadingOverlay } from '@uhg-abyss/web/ui/LoadingOverlay';
import { config } from '@uhg-abyss/web/tools/config';
import { lagoon } from '@optum-lagoon/sdk';
import { store } from '@src/store';

const themeOverride = {
  enterpriseFont: true, // only use this flag for UHC theme
};
const theme = createTheme('uhc', themeOverride);

createStore({
  registration: {
    claimInfo: {},
    accountInfo: {},
    companyName: '',
    portalAccess: {},
    apim: {},
  },
});

export const browser = () => {
  const [lagoonLoading, setLagoonLoading] = useState(true);

  useEffect(() => {
    const initializeLagoon = async () => {
      try {
        const proxyOptions = {
          baseUrl: config('REGISTRATION_LAGOON_PROXY_BASE_URL'),
        };
        const digisecSchema = {
          loadTables: true,
          loadForms: false,
        };
        await lagoon.initialize(
          'registration',
          config('APP_ENV') === 'local' ? 'dev' : config('APP_ENV'),
          {
            ...digisecSchema,
            ...(config('ENABLE_SECURE_LAGOON') && { proxyOptions }),
          }
        );
        setLagoonLoading(false);
      } catch {
        setLagoonLoading(false);
      }
    };

    initializeLagoon();
  }, []);

  if (lagoonLoading) {
    return (
      <LoadingOverlay
        isLoading={lagoonLoading}
        loadingTitle="Please Wait"
        ariaLoadingLabel="Page Loading"
        css={{
          'abyss-loading-overlay-root': {
            paddingTop: '500px',
          },
        }}
      />
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <HashRouter>
        <LagoonContext.Provider value={lagoon}>
          <Provider store={store}>
            <StateMachineProvider>
              <App />
            </StateMachineProvider>
          </Provider>
        </LagoonContext.Provider>
      </HashRouter>
    </ThemeProvider>
  );
};
